import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "kn_lang";
const LangContext = createContext(null);

export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "kar", label: "ကညီ", name: "Karen" },
  { code: "my", label: "မြန်မာ", name: "Burmese" },
];

const STRINGS = {
  brand: { en: "Kawthoolei Army", kar: "ကီၢ်သူလ့ၤသုးမုၢ်ဒိၣ်", my: "ကော့သူးလေ့ တပ်မတော်" },
  tagline: { en: "Official Communications", kar: "တၢ်ဆဲးကျိးတၢ်ကစီၣ်", my: "တရားဝင် ဆက်သွယ်ရေး" },
  nav_home: { en: "Home", kar: "ဟံၣ်", my: "ပင်မ" },
  nav_news: { en: "News", kar: "တၢ်ကစီၣ်", my: "သတင်း" },
  nav_gallery: { en: "Gallery", kar: "တၢ်ဂီၤ", my: "ပုံပြခန်း" },
  nav_events: { en: "Events", kar: "မူး", my: "ပွဲ" },
  nav_about: { en: "About", kar: "ဘၣ်ဃး", my: "အကြောင်း" },
  nav_contact: { en: "Contact", kar: "ဆဲးကျိး", my: "ဆက်သွယ်ရန်" },
  nav_admin: { en: "Admin", kar: "ပၢဆှၢ", my: "စီမံ" },
  read_more: { en: "Read More", kar: "ဖးအါထီၣ်", my: "ဆက်ဖတ်ရန်" },
  latest_news: { en: "Latest News", kar: "တၢ်ကစီၣ်အသီ", my: "နောက်ဆုံးသတင်း" },
  upcoming_events: { en: "Upcoming Events", kar: "မူးလၢကဟဲ", my: "လာမည့်ပွဲများ" },
  view_all: { en: "View All", kar: "ကွၢ်ခဲလၢာ်", my: "အားလုံးကြည့်ရန်" },
  hero_section: { en: "Press Releases & Field Updates", kar: "လံာ်တၢ်ပာ်ဖျါ", my: "သတင်းထုတ်ပြန်ချက်များ" },
  about_title: { en: "About Kawthoolei Army", kar: "ဘၣ်ဃးကီၢ်ကၠီၣ်တဲၣ်သုးဖိ", my: "ကော့သူးလေ့တပ်မတော် အကြောင်း" },
  about_p1: {
    en: "The Kawthoolei Army serves as the defense force of the Karen people, dedicated to protecting our communities, homeland, and way of life. For more than seven decades, we have stood resolute against oppression and worked toward a free, federal Kawthoolei.",
    kar: "ကီၢ်သူလ့ၤသုးမုၢ်ဒိၣ် ဆီၣ်ထွဲမၤစၢၤပှၤဂီၢ်မုၢ်ကညီ လၢကီၢ်ပူၤ။",
    my: "ကော့သူးလေ့ တပ်မတော်သည် ကရင်လူမျိုးတို့၏ ကာကွယ်ရေးတပ်အဖြစ် မိမိတို့လူထု၊ မိခင်မြေနှင့် ဘဝနေထိုင်မှုပုံစံကို ကာကွယ်စောင့်ရှောက်ရန် ကတိကဝတ်ပြုထားသည်။",
  },
  about_p2: {
    en: "Through discipline, service, and respect for international humanitarian law, we work alongside civilian institutions to safeguard fundamental human rights and humanitarian access.",
    kar: "လၢတၢ်ပၢဆှၢသကိးတၢ်အပူၤ ပမၤသကိးပှၤဂီၢ်မုၢ်",
    my: "စည်းကမ်း၊ အမှုထမ်းခြင်းနှင့် နိုင်ငံတကာ လူသားချင်းစာနာမှု ဥပဒေကို လေးစားလိုက်နာခြင်းဖြင့် ပြည်သူ့အဖွဲ့အစည်းများနှင့် ပူးပေါင်းကာ အခြေခံလူ့အခွင့်အရေးများကို စောင့်ရှောက်သည်။",
  },
  signin: { en: "Sign in", kar: "နုာ်လီၤ", my: "ဝင်ရောက်ရန်" },
  signout: { en: "Sign out", kar: "ဟးထီၣ်", my: "ထွက်ရန်" },
  email: { en: "Email", kar: "အံမ့ၣ်လ်", my: "အီးမေးလ်" },
  password: { en: "Password", kar: "နီၣ်ဂံၢ်ခူသူၣ်", my: "စကားဝှက်" },
  admin_login: { en: "Administrator Login", kar: "ပၢဆှၢပှၤနုာ်လီၤ", my: "စီမံခန့်ခွဲသူ ဝင်ရောက်ရန်" },
  no_data: { en: "Nothing here yet.", kar: "တၢ်တအိၣ်ဒံးဘၣ်", my: "မရှိသေးပါ" },
  footer_rights: {
    en: "All rights reserved.",
    kar: "ခွဲးယာ်ခဲလၢာ်ဘၣ်တၢ်ပၢၤဃာ်",
    my: "မူပိုင်ခွင့် အားလုံး လွှဲထားသည်။",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || "en");

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    const html = document.documentElement;
    html.classList.toggle("font-burmese", lang === "my");
    html.classList.toggle("lang-kar", lang === "kar");
    html.classList.toggle("lang-my", lang === "my");
    html.classList.toggle("lang-en", lang === "en");
  }, [lang]);

  const t = (key) => {
    const entry = STRINGS[key];
    if (!entry) return key;
    return entry[lang] || entry.en || key;
  };

  // Pick a TriText field (en/kar/my) with fallback
  const tri = (obj) => {
    if (!obj) return "";
    return obj[lang] || obj.en || obj.kar || obj.my || "";
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t, tri }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
